'use client'
import { __awaiter } from '../../../_virtual/_tslib.js';
import { InjectedWalletBase } from '../../injected/InjectedWalletBase.js';
import { logger } from '../logger.js';

const getConnectorConstructorInjectedWallet = (key, wallet) => {
    const { shortName } = wallet;
    const name = shortName || wallet.name;
    const walletConnectorFallback = Boolean(wallet.walletConnect);
    return class extends InjectedWalletBase {
        constructor() {
            super(...arguments);
            this.name = name;
            this.walletConnectorFallback = walletConnectorFallback;
            // this is the key from the wallet book entry so that we don't purely rely on the normalized name
            this.overrideKey = key;
        }
        getAddress() {
            const _super = Object.create(null, {
                getAddress: { get: () => super.getAddress }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (this.isInstalledOnBrowser()) {
                    return _super.getAddress.call(this);
                }
                const inAppBrowserBase = (_a = this.metadata) === null || _a === void 0 ? void 0 : _a.inAppBrowserUrl;
                if (!inAppBrowserBase) {
                    const error = new Error(`No inAppBrowserBase found for ${this.name}.`);
                    logger.error(error.message);
                    throw error;
                }
                window.location.href = `${inAppBrowserBase}/${window.location.href}`;
                return undefined;
            });
        }
    };
};

export { getConnectorConstructorInjectedWallet };
